import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Skeleton, Box, VStack } from "@chakra-ui/react";

// Genérico o suficiente para Recebíveis, Vínculo detalhe e Comprovação — cada tela só
// declara suas `columns` ({ key, label, align, render? }) e passa os `rows` já prontos.
// `renderMobileRow` (opcional) troca a tabela por uma lista de cartões abaixo de `md`,
// para telas cuja tabela tem colunas demais para caber num celular.
export default function DataTable({ columns, rows, isLoading, emptyState, footer, renderMobileRow }) {
  if (!isLoading && rows.length === 0 && emptyState) {
    return emptyState;
  }

  return (
    <Box>
      {renderMobileRow ? (
        <VStack
          align="stretch"
          spacing={0}
          display={{ base: "flex", md: "none" }}
          divider={<Box borderBottom="1px solid" borderColor="app-border" />}
        >
          {isLoading
            ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} height="56px" my={2} />)
            : rows.map((row, i) => <Box key={row.id ?? i}>{renderMobileRow(row)}</Box>)}
        </VStack>
      ) : null}
      <TableContainer overflowX="auto" display={renderMobileRow ? { base: "none", md: "block" } : undefined}>
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              {columns.map((col) => (
                <Th key={col.key} textAlign={col.align}>
                  {col.label}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {isLoading
              ? Array.from({ length: 4 }).map((_, i) => (
                  <Tr key={i}>
                    {columns.map((col) => (
                      <Td key={col.key}>
                        <Skeleton height="16px" />
                      </Td>
                    ))}
                  </Tr>
                ))
              : rows.map((row, i) => (
                  <Tr key={row.id ?? i}>
                    {columns.map((col) => (
                      <Td key={col.key} textAlign={col.align}>
                        {col.render ? col.render(row) : row[col.key]}
                      </Td>
                    ))}
                  </Tr>
                ))}
          </Tbody>
        </Table>
      </TableContainer>
      {footer}
    </Box>
  );
}
